import { staticListWithDefaultSelection } from '../engine/default-handlers';
import { defineStaticListFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const defaultMetricMode = {
  value: 'posting',
  label: 'Unweighted',
  limit: 1,
};
export const METRIC_MODE_OPTIONS = [
  defaultMetricMode,
  { value: 'expected_hires', label: 'Weighted by Expected Hires', limit: 1 },
];

export const metricModeDescriptor = defineStaticListFilter({
  definition: {
    id: FilterId.METRIC_MODE,
    name: 'Metric Mode',
    selections: [],
    type: FilterType.STATIC_LIST,
    isVisible: true,
  },
  handler: staticListWithDefaultSelection(defaultMetricMode),
});
